import { Locale } from 'ha/i18n';

import formatDate from './formatDate';
import { ISODate } from './types';

// ISODate
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

const toLocalizedString = (locale: Locale) => (isoDate?: ISODate): string =>
  formatDate(locale, 'L', isoDate);

export default toLocalizedString;
